import React, { useState, useEffect } from 'react';
import './sidebar.css';
import logo from './../assets/ithyaraa-logo.png';
import { FiChevronRight, FiChevronDown } from 'react-icons/fi';
import { RiDashboardFill } from 'react-icons/ri';
import { useNavigate, useLocation } from 'react-router-dom';
import { mainMenu } from './menus';

const SidebarMenu = ({ keymenu, activeMenu, userRole }) => {
    const [openMenu, setOpenMenu] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();

    const navigation = (link) => {
        navigate(link);
    };

    useEffect(() => {
        const currentPath = location.pathname;

        const matched = keymenu.find(menu => {
            // Check direct activeMenu match
            if (menu.menuID === activeMenu) return true;

            // Check direct menu url match
            if (menu.url && menu.url !== '/' && currentPath.startsWith(menu.url)) return true;

            // Check submenus
            return menu.subMenu?.some(sub => {
                if (sub.menuID === activeMenu) return true;
                if (!sub.url) return false;

                const cleanSubUrl = sub.url.split('?')[0];
                if (currentPath === cleanSubUrl) return true;

                // Match base path e.g. /section-items/list vs /section-items/add or /section-items/edit/123
                const basePath = cleanSubUrl.replace(/\/(list|add|featured|details|edit)$/, '');
                if (basePath && basePath !== '/' && currentPath.startsWith(basePath)) return true;

                return false;
            });
        });

        if (matched) {
            setOpenMenu(matched.id);
        }
    }, [activeMenu, keymenu, location.pathname]);

    const handleToggle = (menu) => {
        if (menu.subMenu && menu.subMenu?.length > 0) {
            setOpenMenu(prev => (prev === menu.id ? null : menu.id));
        } else {
            navigation(menu.url);
        }
    };

    // Filter menus based on role
    const filteredMenu = keymenu.filter(menu => {
        if (menu.allowedRoles && !menu.allowedRoles.includes(userRole)) {
            return false;
        }
        return true;
    });

    const isSubActive = (sub) => {
        if (activeMenu === sub.menuID) return true;
        const cleanSubUrl = sub.url ? sub.url.split('?')[0] : '';
        return cleanSubUrl && location.pathname === cleanSubUrl;
    };

    return (
        <div className='sidebar--component'>
            {filteredMenu?.map((menu) => {
                const currentPath = location.pathname;
                const isParentActive =
                    menu.menuID === activeMenu ||
                    (menu.url && menu.url !== '/' && currentPath.startsWith(menu.url)) ||
                    menu.subMenu?.some(sub => {
                        if (sub.menuID === activeMenu) return true;
                        const cleanSubUrl = sub.url ? sub.url.split('?')[0] : '';
                        return cleanSubUrl && currentPath === cleanSubUrl;
                    });

                return (
                    <div key={menu.menuID} className='menu-item'>
                        <div
                            className={`border menu-title ${isParentActive ? 'active-menu' : ''}`}
                            onClick={() => handleToggle(menu)}
                        >
                            <div className="left">
                                <span className="icon">
                                    {menu.icon ? menu.icon : <RiDashboardFill />}
                                </span>
                                <span className="text-menu">{menu.title}</span>
                            </div>
                            {menu.subMenu?.length > 0 && (
                                <div className="right">
                                    {openMenu === menu.id ? <FiChevronDown /> : <FiChevronRight />}
                                </div>
                            )}
                        </div>

                        {openMenu === menu.id && menu.subMenu?.length > 0 && (
                            <div className="submenu">
                                {menu.subMenu?.map((sub) => {
                                    const activeSub = isSubActive(sub);
                                    return (
                                        <div
                                            key={sub.menuID}
                                            className={`submenu-item ${activeSub ? 'active-submenu' : ''}`}
                                            onClick={() => navigation(sub.url)}
                                        >
                                            <span className="icon">{sub.icon}</span>
                                            <span className="text">{sub.title}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

const Sidebar = ({ activeMenu }) => {
    const navigate = useNavigate();

    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
    };

    const userRole = getCookie('_role') || 'admin';

    const handleLogout = () => {
        document.cookie = '_at=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
        document.cookie = '_rt=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
        document.cookie = '_iil=false; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
        document.cookie = '_role=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';

        navigate('/login');
    };

    return (
        <aside className='sidebar'>
            <div className="logo-sidebar">
                <img src={logo} alt="logo" />
            </div>
            <div className="greet-user">
                <p className='welcome-text-gu'>Welcome Back</p>
                <p className='welcome-name'>
                    {userRole === 'admin' ? 'Ithyaraa Admin' : 'Ithyaraa Manager'}
                </p>
            </div>

            <div className="sidebar-menu">
                <p className='sidebar-p'>Main</p>
                <SidebarMenu keymenu={mainMenu} activeMenu={activeMenu} userRole={userRole} />
            </div>
            <div className="bottom-sidebar">
                <button className='primary-button-gta' onClick={() => navigate('/')}>Go to Admin</button>
                <button className='logout-button' onClick={() => handleLogout()}>Logout</button>
            </div>
        </aside>
    );
};

export default Sidebar;